import React from 'react'

const UnknownIcon = () => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="64" height="64" rx="8" fill="#E0E0E0" />
                                                        <path d="M48 18L38 8H20C18.9 8 18 8.9 18 10V54C18 55.1 18.9 56 20 56H44C45.1 56 46 55.1 46 54V20L48 18Z" fill="white" stroke="#9E9E9E" stroke-width="2" />
                                                        <path d="M38 8V20H50" stroke="#9E9E9E" stroke-width="2" />
                                                        <circle cx="32" cy="38" r="8" stroke="#9E9E9E" stroke-width="2" fill="none" />
                                                        <text x="32" y="42" text-anchor="middle" font-size="10" font-family="Arial" fill="#9E9E9E">?</text>
                                                    </svg>
  )
}

export default UnknownIcon